'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Controllable = require('../../decorators/Controllable');

var _Controllable2 = _interopRequireDefault(_Controllable);

var _Functions = require('../../core/Functions');

var _SyntheticEvent = require('../../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _pickValidProps = require('react-utils/pickValidProps');

var _pickValidProps2 = _interopRequireDefault(_pickValidProps);

var _focusStylesListener = require('../../listeners/focusStylesListener');

var _refObject = require('../../utils/propTypes/refObject');

var _refObject2 = _interopRequireDefault(_refObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var UISelectWithInputAnchor = _react2.default.createClass({
  displayName: 'UISelectWithInputAnchor',

  propTypes: {
    autoFocus: _react.PropTypes.bool,
    disabled: _react.PropTypes.bool,
    error: _react.PropTypes.bool,
    menuWidth: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.oneOf(['auto'])]),
    inputComponent: _react.PropTypes.func.isRequired,
    inputRef: _refObject2.default,
    isOpen: _react.PropTypes.bool.isRequired,
    onInputValueChange: _react.PropTypes.func,
    onOpenChange: _react.PropTypes.func,
    placeholder: _react.PropTypes.string,
    readOnly: _react.PropTypes.bool,
    searchClassName: _react.PropTypes.string,
    selectComponent: _react.PropTypes.func.isRequired,
    selectRef: _react.PropTypes.func,
    inputValue: _react.PropTypes.string,
    value: _react.PropTypes.any
  },

  focus: function focus() {
    if (this._inputRef) {
      this._inputRef.focus();
    }
  },
  selectRefCallback: function selectRefCallback(ref) {
    var selectRef = this.props.selectRef;


    this._selectRef = ref;

    if (selectRef) {
      selectRef(ref);
    }
  },
  getInternalSelect: function getInternalSelect() {
    // Return our react-select component instance, or null
    if (!this._selectRef) {
      return null;
    }
    if (!this._selectRef.select) {
      return this._selectRef;
    }
    // _selectRef must be an <Async> or <Creatable> wrapper
    return this._selectRef.select;
  },
  getInternalAsyncSelect: function getInternalAsyncSelect() {
    // Return our react-select Async instance, or null
    if (!this._selectRef || !this._selectRef.select) {
      return null;
    }
    return this._selectRef;
  },
  handleInputKeyDown: function handleInputKeyDown(evt) {
    var readOnly = this.props.readOnly;

    var internalSelect = this.getInternalSelect();
    if (internalSelect && !readOnly) {
      internalSelect.handleKeyDown(evt);
    }
  },
  handleInputChange: function handleInputChange(evt) {
    var onInputValueChange = this.props.onInputValueChange;

    onInputValueChange(evt);
    var internalSelect = this.getInternalSelect();
    if (internalSelect) {
      internalSelect.handleInputChange(evt);
    }
  },
  handleInputFocus: function handleInputFocus() {
    var _props = this.props,
        onOpenChange = _props.onOpenChange,
        readOnly = _props.readOnly;

    var internalSelect = this.getInternalSelect();
    if (readOnly) return;
    if (internalSelect) {
      internalSelect.setState({ isOpen: true });
    }
    (0, _Functions.callIfPossible)(onOpenChange, (0, _SyntheticEvent2.default)(true));
  },
  handleInputBlur: function handleInputBlur() {
    var onOpenChange = this.props.onOpenChange;

    if (!(0, _focusStylesListener.isPageInKeyboardMode)()) return;
    (0, _Functions.callIfPossible)(onOpenChange, (0, _SyntheticEvent2.default)(false));
  },
  inputRefCallback: function inputRefCallback(ref) {
    this._inputRef = ref;
  },
  render: function render() {
    var _props2 = this.props,
        autoFocus = _props2.autoFocus,
        disabled = _props2.disabled,
        error = _props2.error,
        inputComponent = _props2.inputComponent,
        inputRef = _props2.inputRef,
        inputValue = _props2.inputValue,
        __onInputValueChange = _props2.onInputValueChange,
        __onOpenChange = _props2.onOpenChange,
        onPaste = _props2.onPaste,
        placeholder = _props2.placeholder,
        readOnly = _props2.readOnly,
        selectComponent = _props2.selectComponent,
        __selectRef = _props2.selectRef,
        tabIndex = _props2.tabIndex,
        value = _props2.value,
        rest = _objectWithoutProperties(_props2, ['autoFocus', 'disabled', 'error', 'inputComponent', 'inputRef', 'inputValue', 'onInputValueChange', 'onOpenChange', 'onPaste', 'placeholder', 'readOnly', 'selectComponent', 'selectRef', 'tabIndex', 'value']);

    var InputComponent = inputComponent;
    var SelectComponent = selectComponent;

    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(InputComponent, _extends({}, (0, _pickValidProps2.default)({}, this.props), {
        autoFocus: autoFocus,
        disabled: disabled,
        'aria-invalid': error,
        inputRef: inputRef,
        onBlur: this.handleInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.handleInputFocus,
        onKeyDown: this.handleInputKeyDown,
        onPaste: onPaste,
        placeholder: placeholder,
        readOnly: readOnly,
        ref: this.inputRefCallback,
        tabIndex: tabIndex,
        value: inputValue
      })),
      _react2.default.createElement(SelectComponent, _extends({}, rest, {
        autosize: false,
        className: 'hidden',
        disabled: disabled,
        ref: this.selectRefCallback,
        scrollMenuIntoView: false,
        value: value
      }))
    );
  }
});

exports.default = (0, _Controllable2.default)(UISelectWithInputAnchor, ['inputValue']);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/input/internal/UISelectWithInputAnchor.js
// module id = 560
// module chunks = 3 4 5